/**
 * Django REST Framework serializer errors are often nested objects and arrays.
 * Avoid String(object) which becomes "[object Object]".
 */
export function formatDrfValidationDetails(details: unknown, depth = 0): string {
  if (depth > 8) return '…'
  if (details === null || details === undefined) return ''
  if (typeof details === 'string' || typeof details === 'number' || typeof details === 'boolean') {
    return String(details)
  }
  if (Array.isArray(details)) {
    const parts = details.map((item) => formatDrfValidationDetails(item, depth + 1)).filter((s) => s.length > 0)
    return parts.join('; ')
  }
  if (typeof details === 'object') {
    const entries = Object.entries(details as Record<string, unknown>)
    const parts = entries.map(([key, value]) => {
      const inner = formatDrfValidationDetails(value, depth + 1)
      return inner ? `${key}: ${inner}` : key
    })
    return parts.join('; ')
  }
  return String(details)
}
